(function () {
  function init(root) {
    if (!root || root.dataset.barefootPromoReady === 'true') return;
    root.dataset.barefootPromoReady = 'true';
    var carousel = root.querySelector('[data-barefoot-carousel]');
    if (!carousel) return;
    carousel.addEventListener('click', function (event) {
      var swatch = event.target.closest('[data-hm-bundle-swatch]');
      if (!swatch || !carousel.contains(swatch) || !swatch.dataset.variantId) return;
      var card = swatch.closest('.barefoot-card');
      if (!card) return;
      var image = card.querySelector('.barefoot-card__image img');
      if (image) {
        if (!image.hmBundleOriginal) image.hmBundleOriginal = { src: image.getAttribute('src'), srcset: image.getAttribute('srcset') };
        var source = swatch.dataset.variantImage;
        if (source) {
          image.removeAttribute('srcset');
          image.src = source;
        } else {
          image.setAttribute('src', image.hmBundleOriginal.src);
          if (image.hmBundleOriginal.srcset) image.setAttribute('srcset', image.hmBundleOriginal.srcset);
          else image.removeAttribute('srcset');
        }
      }
      card.dataset.hmBundleVariant = swatch.dataset.variantId;
      card.querySelectorAll('[data-hm-bundle-swatch]').forEach(function (button) { button.setAttribute('aria-pressed', button === swatch ? 'true' : 'false'); });
      var shop = card.querySelector('.barefoot-card__button');
      if (shop) shop.href = swatch.dataset.variantUrl;
    });
    var previous = root.querySelector('[data-barefoot-carousel-prev]');
    var next = root.querySelector('[data-barefoot-carousel-next]');
    function move(direction) {
      var card = carousel.querySelector('.barefoot-card');
      var distance = card ? card.getBoundingClientRect().width + 20 : carousel.clientWidth * 0.8;
      carousel.scrollBy({ left: distance * direction, behavior: 'smooth' });
    }
    if (previous) previous.addEventListener('click', function () { move(-1); });
    if (next) next.addEventListener('click', function () { move(1); });
  }
  function initAll(scope) { (scope || document).querySelectorAll('[data-barefoot-promo]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
})();

(function () {
  if (window.hmLifestyleMarqueeReady) return;
  window.hmLifestyleMarqueeReady = true;
  function init(strip) {
    if (strip.hmMarqueeCleanup) return;
    var originals = Array.from(strip.children), clones = [], period = 0, position = 0;
    var frame, last = 0, hover = false, touching = false, focused = false, selected = false, resumeAt = 0, dragX = null;
    var motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    var mobile = window.matchMedia('(max-width: 749px)');
    var events = [];
    function on(target, type, fn) { target.addEventListener(type, fn); events.push(function () { target.removeEventListener(type, fn); }); }
    function enabled() { return strip.dataset.autoplay !== 'false' && !motion.matches && originals.length > 1; }
    function rebuild() {
      clones.forEach(function (c) { c.remove(); }); clones = [];
      strip.classList.toggle('hm-lifestyle-loop', enabled()); period = 0;
      if (!enabled()) return;
      period = originals.reduce(function (sum, item) { return sum + item.getBoundingClientRect().width; }, 0);
      if (!period) return;
      var copies = Math.ceil(strip.clientWidth / period) + 2;
      for (var i = 0; i < copies; i++) originals.forEach(function (item) {
        var copy = item.cloneNode(true); copy.removeAttribute('data-shopify-editor-block'); copy.removeAttribute('id');
        copy.setAttribute('aria-hidden', 'true'); copy.setAttribute('inert', '');
        copy.querySelectorAll('[id]').forEach(function (e) { e.removeAttribute('id'); });
        copy.querySelectorAll('img').forEach(function (img) { img.loading = 'eager'; img.draggable = false; });
        strip.appendChild(copy); clones.push(copy);
      });
      position = period; strip.scrollLeft = position;
    }
    function normalize() {
      if (!period) return;
      var x = strip.scrollLeft;
      if (x < period || x >= period * 2) {
        position = period + ((x % period) + period) % period; strip.scrollLeft = position;
      }
    }
    function tick(now) {
      if (!strip.isConnected) { strip.hmMarqueeCleanup(); return; }
      var dt = Math.min(now - (last || now), 50); last = now;
      if (period && !document.hidden && !touching && !focused && !selected && !hover && now > resumeAt) {
        var seconds = (Number(strip.dataset.speed) || 5) * (mobile.matches ? 1.2 : 1);
        position += dt / 1000 * originals[0].getBoundingClientRect().width / seconds;
        position = period + ((position - period) % period + period) % period;
        strip.scrollLeft = position;
      }
      frame = requestAnimationFrame(tick);
    }
    on(strip, 'pointerenter', function (e) { if (e.pointerType === 'mouse' && strip.dataset.hoverPause !== 'false') hover = true; });
    on(strip, 'pointerleave', function () { hover = false; });
    on(strip, 'pointerdown', function (e) {
      touching = true; position = strip.scrollLeft;
      if (e.pointerType === 'mouse' && e.button === 0 && period) { dragX = e.clientX; strip.setPointerCapture(e.pointerId); strip.classList.add('hm-lifestyle-dragging'); e.preventDefault(); }
    });
    on(strip, 'pointermove', function (e) {
      if (dragX === null) return;
      strip.scrollLeft += dragX - e.clientX; dragX = e.clientX; normalize(); position = strip.scrollLeft;
    });
    function release() { touching = false; dragX = null; strip.classList.remove('hm-lifestyle-dragging'); resumeAt = performance.now() + 900; position = strip.scrollLeft; }
    on(window, 'pointerup', release); on(window, 'pointercancel', release);
    on(strip, 'touchstart', function () { touching = true; });
    on(strip, 'touchmove', function () { touching = true; });
    on(strip, 'touchend', release); on(strip, 'touchcancel', release);
    on(strip, 'dragstart', function (e) { if (period) e.preventDefault(); });
    on(strip, 'scroll', function () { if (touching || performance.now() < resumeAt || focused || hover) { normalize(); position = strip.scrollLeft; } });
    on(strip, 'wheel', function () { resumeAt = performance.now() + 900; });
    on(strip, 'focusin', function () { focused = strip.matches(':focus-visible'); });
    on(strip, 'focusout', function () { focused = false; position = strip.scrollLeft; });
    on(strip, 'keydown', function (e) { if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') { e.preventDefault(); strip.scrollLeft += (e.key === 'ArrowRight' ? 1 : -1) * originals[0].getBoundingClientRect().width; normalize(); position = strip.scrollLeft; } });
    on(document, 'shopify:block:select', function (e) { if (strip.contains(e.target)) { selected = true; e.target.scrollIntoView({ block: 'nearest', inline: 'nearest' }); } });
    on(document, 'shopify:block:deselect', function () { selected = false; position = strip.scrollLeft; });
    on(motion, 'change', rebuild);
    var observer = new ResizeObserver(rebuild); observer.observe(strip);
    strip.hmMarqueeCleanup = function () { cancelAnimationFrame(frame); observer.disconnect(); events.forEach(function (off) { off(); }); clones.forEach(function (c) { c.remove(); }); delete strip.hmMarqueeCleanup; };
    rebuild(); frame = requestAnimationFrame(tick);
  }
  function all(scope) { scope.querySelectorAll('[data-hm-lifestyle]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { all(document); }); else all(document);
  document.addEventListener('shopify:section:load', function (e) { all(e.target); });
  document.addEventListener('shopify:section:unload', function (e) { e.target.querySelectorAll('[data-hm-lifestyle]').forEach(function (strip) { if (strip.hmMarqueeCleanup) strip.hmMarqueeCleanup(); }); });
})();
